export const UPLOAD_CSV_REQUEST = "UPLOAD_CSV_REQUEST";
export const UPLOAD_CSV_SUCCESS = "UPLOAD_CSV_SUCCESS";
export const UPLOAD_CSV_FAIL = "UPLOAD_CSV_FAIL";
